import React from "react"

import { connect } from "scrivito"

import { AppSidebar } from "./AppSidebar"
import { useAppSidebarModel } from "./model/useAppSidebarModel"

function AppSidebarConnectorComponent() {
  return <AppSidebar {...useAppSidebarModel()} />
}

export const AppSidebarConnector = React.memo(
  connect(AppSidebarConnectorComponent)
)
